import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import DataTable from "../../component/DataTable";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const tableHeader = ["Date", "Name", "Status"];
const tbody = ["createdAt", "name", "status"];

export default function GalleryCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    ApiRequest("GET", ApiEndpoints.galleryCategory.list)
      .then((response) => setCategories(response.gallery_categories || []))
      .catch((error) => toast.error(error.response?.data?.message || "Unable to load categories."));
  }, []);

  const handleDelete = useCallback(async (gallerycategory_id) => {
    if (!window.confirm("Delete this gallery category?")) return;
    try {
      const response = await ApiRequest("POST", ApiEndpoints.galleryCategory.delete, { gallerycategory_id });
      toast.success(response.message);
      setCategories((current) => current.filter((category) => category._id !== gallerycategory_id));
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete category.");
    }
  }, []);

  const pagename = { name: "Gallery Management", user: "Admin", innerpage: "Gallery Categories" };
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-gallery-category">Add +</Link>
        <DataTable data={categories} tableHeader={tableHeader} tbody={tbody}
          editPath="edit-gallery-category" onDelete={handleDelete} />
      </div>
    </>
  );
}
